import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';
import { green } from '@mui/material/colors';



export default function OutlinedCard({ iconPath, headerContent, bodyContent, fullContent }) {

    const { t } = useTranslation();
    const [expanded, setExpanded] = React.useState(false);

    const card = (
        <React.Fragment>
            <CardContent sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: 14, mb: 2 }} color="text.secondary" gutterBottom>
                    <img alt="icon" src={iconPath} className='tw-w-12 tw-h-12 tw-overflow-hidden tw-mx-auto' />
                </Typography>
                <Typography variant="h4" component="div" sx={{ mb: 2, fontWeight: 'bold' }} >
                    {t(headerContent)}
                </Typography>
                <Typography sx={{ mb: 1.5, color: "text.secondary", textAlign: 'justify', ...( !expanded && { display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden', }), transition: 'all 0.3s ease', }} >
                    {expanded && fullContent ? t(fullContent) : t(bodyContent)}
                </Typography>
                <button 
                    onClick={() => setExpanded(!expanded)}
                    className="btn btn-danger text-white tw-font-semibold tw-px-4 tw-py-2 tw-rounded-lg tw-mt-3 hover:tw-opacity-90 tw-transition-opacity" 
                    style={{ fontSize: '12px', marginTop: '12px' }}
                >
                    {expanded ? "Show Less" : t("learn-more")}
                </button>
            </CardContent>
        </React.Fragment>
    );

    return (
        <Box sx={{ minWidth: 275 }}>
            <Card variant="none">{card}</Card>
        </Box>
    );
}